import { Tool } from '../../types';

export const securityTools: Tool[] = [
  {
    id: 'lastpass',
    name: 'LastPass',
    category: 'Security & Privacy',
    description: 'Password management and secure data storage',
    pricing: ['free', 'medium'],
    features: ['security', 'mobile', 'ease-of-use'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['security', 'streamline-operations'],
    industries: ['technology', 'finance', 'consulting'],
    website: 'https://www.lastpass.com',
    imageUrl: 'https://logo.clearbit.com/lastpass.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: '1password',
    name: '1Password',
    category: 'Security & Privacy',
    description: 'Team password management and secure sharing',
    pricing: ['medium'],
    features: ['security', 'mobile', 'ease-of-use'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['security', 'streamline-operations'],
    industries: ['technology', 'finance', 'consulting'],
    website: 'https://1password.com',
    imageUrl: 'https://logo.clearbit.com/1password.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];